import {
  CollectionConditionInput,
  OFFER_PAYOUT_TYPE,
  ORDER_VALUE_OPERATOR,
  PayoutRuleInput,
  PayoutRuleOperator,
  ProductConditionInput,
} from '@frontend/applications/AffiliatesApp/types/globalTypes';
import { ClientForSync, IPayoutVariant } from '../../OfferForm';

export interface IPayoutRules {
  open: boolean;
  onOpenChange: (value: boolean) => void;
  payout: IPayoutVariant;
  formattedConversionType: string;
  payoutState: PayoutState;
  updatePayoutState: <K extends keyof PayoutState>(key: K, value: PayoutState[K]) => void;
  handleEditPayout: (index: number) => void;
  payoutIndex: number;
  payoutRules: PayoutRuleInput[];
  conditions: PayoutRuleConditionsInput[];
  onPayoutRulesChange: (rules: PayoutRuleInput[]) => void;
  onConditionsChange: (conditions: PayoutRuleConditionsInput[]) => void;
  clientsForSync?: ClientForSync[];
}

export interface RuleCommission {
  flatPayout: number | null;
  percentPayout: number | null;
}

export enum CONDITION_TYPE {
  All_CONDITION = 'all conditions',
  ANY_CONDITION = 'any conditions',
}

export interface StandaloneInputProps {
  initialValue: number | null;
  onChange: (value: number) => void;
  placeholder: string;
  prefix?: string;
  suffix?: string;
  max?: number;
}

export const OPERATOR_DISPLAY = {
  [ORDER_VALUE_OPERATOR.EQUAL_TO]: '=',
  [ORDER_VALUE_OPERATOR.LESS_THAN]: '<',
  [ORDER_VALUE_OPERATOR.LESS_THAN_OR_EQUAL_TO]: '≤',
  [ORDER_VALUE_OPERATOR.GREATER_THAN]: '>',
  [ORDER_VALUE_OPERATOR.GREATER_THAN_OR_EQUAL_TO]: '≥',
};

export enum RecurringOrderType {
  // FIRST_ORDER = 'Limit payout to the first order',
  // MULTIPLE_ORDERS = 'Limit payout to multiple recurring orders',
  ALL_ORDERS = 'Payout applies to all recurring orders',
}

export enum PayoutAction {
  ADD = 'ADD',
  NOUPDATE = 'NOUPDATE',
  REMOVE = 'REMOVE',
  UPDATE = 'UPDATE',
}

export interface RecurringLimit {
  isLimitPayoutToFirstOrder: boolean;
  isPayoutAppliedToAllRecurringOrders: boolean;
  limitPayoutToMultipleRecurringOrder: number | null;
}

export enum ConditionType {
  PRODUCT = 'Product',
  COLLECTIONS = 'Collections',
  ORDER_SUBTOTAL = 'Order Subtotal',
  DATE_RANGE = 'Date Range',
  RECURRING_ORDER = 'All Recurring Orders',
}

export enum ConditionTypeMap {
  PRODUCT = 'product',
  COLLECTIONS = 'collection',
  ORDER_SUBTOTAL = 'order_subtotal',
  DATE_RANGE = 'date_range',
  RECURRING_ORDER = 'recurring',
}

export interface PayoutState {
  tempPayoutTitles: string;
  tempPercentPayout: number;
  tempFlatPayout: number;
  tempPayoutType: OFFER_PAYOUT_TYPE;
}

export interface PayoutTag {
  id: string;
  name: string;
  type: 'collection' | 'product' | 'order_subtotal' | 'date_range' | 'recurring';
  bgColor?: string;
  textColor?: string;
  imageUrl?: string;
  totalProductCount?: number;
  recurringLimit?: {
    isLimitPayoutToFirstOrder: boolean;
    isPayoutAppliedToAllRecurringOrders: boolean;
    limitPayoutToMultipleRecurringOrder?: number;
  };
}

export interface PayoutTagsProps {
  tags: PayoutTag[];
  className?: string;
  showDivider?: boolean;
  totalProductCount?: number;
}

export interface OrderSubtotalConditionInput {
  operator: ORDER_VALUE_OPERATOR;
  value: number;
}

export interface DateRangeConditionInput {
  startDate: Date | null;
  endDate: Date | null;
}

export interface PayoutRuleConditionsInput {
  type?: ConditionType | null;
  action: PayoutAction;
  id: string | null;
  operator: PayoutRuleOperator;
  selectedStoreId?: string | null;
  collections?: CollectionConditionInput[];
  products?: ProductConditionInput[];
  orderSubtotal?: OrderSubtotalConditionInput;
  duration?: DateRangeConditionInput;
  recurringLimit?: RecurringLimit;
}
